import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TipoProjetoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Tipo de Projetos por id
     * @param id ID da Tipo de Projetos
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "clientes/tipo-projeto/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Projetos
     * @param id ID da Tipo de Projetos
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/tipo-projeto"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Projetos
     * @param id ID da Tipo de Projetos
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/tipo-projeto"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Tipo de Projetos
     * @param id ID da Tipo de Projetos
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "clientes/tipo-projeto/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Tipo de Projetos
     * @param params Json Tipo de Projetos
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "clientes/tipo-projeto", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Tipo de Projetos
     * @param params Json Tipo de Projetos
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "clientes/tipo-projeto/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
